export const welcomeBanner = {
  heading: 'Welcome to Help Center',
  subheading: 'Your Virtual Travel Agent',
  bannerAltText: 'Welcome Banner image',
};

export const intentButtons = {
  CHANGE: 'CHANGE',
  CANCEL: 'CANCEL',
  REFUND_STATUS: 'REFUND_STATUS',
  AIRLINE_CREDIT_CONVERSATION_STARTER: 'AIRLINE_CREDIT_CONVERSATION_STARTER',
  SMALL_TALK_HELLO: 'SMALL_TALK_HELLO',
};

export const intentButtonText = {
  [intentButtons.CHANGE]: 'Change a booking',
  [intentButtons.CANCEL]: 'Cancel a booking',
  [intentButtons.REFUND_STATUS]: 'Get refund status',
  [intentButtons.AIRLINE_CREDIT_CONVERSATION_STARTER]: 'Use airline credit',
  [intentButtons.SMALL_TALK_HELLO]: 'Do something else',
};

export const intentButtonMessagePayload = {
  [intentButtons.CHANGE]: {
    messageType: 'POSTBACK',
    text: 'Change a booking',
    intent: 'CHANGE',
  },
  [intentButtons.CANCEL]: {
    messageType: 'POSTBACK',
    text: 'Cancel a booking',
    intent: 'CANCEL',
  },
  [intentButtons.REFUND_STATUS]: {
    messageType: 'POSTBACK',
    text: 'Get refund status',
    intent: 'REFUND_STATUS',
  },
  [intentButtons.AIRLINE_CREDIT_CONVERSATION_STARTER]: {
    messageType: 'POSTBACK',
    text: 'Use airline credit',
    intent: 'AIRLINE_CREDIT_CONVERSATION_STARTER',
    payload: '{"action":"showUseAirlineCreditQuickReplies","intent":"AIRLINE_CREDIT_CONVERSATION_STARTER"}',
  },
  [intentButtons.SMALL_TALK_HELLO]: {
    messageType: 'POSTBACK',
    text: 'Do something else',
    intent: 'SMALL_TALK_HELLO',
    payload: '{"action": "SOMETHING_ELSE_ACTION","intent": "SMALL_TALK_HELLO"}',
  },
};

export const egClickStreamConstants = {
  egClickStreamEventVersion: '1.0.0',
  egClickStreamEventNames: {
    [intentButtons.CHANGE]: 'change_booking.selected',
    [intentButtons.CANCEL]: 'cancel_booking.selected',
    [intentButtons.REFUND_STATUS]: 'get_refund.selected',
    [intentButtons.AIRLINE_CREDIT_CONVERSATION_STARTER]: 'use_airline_credit.selected',
    [intentButtons.SMALL_TALK_HELLO]: 'do_something_else.selected',
    articleLinkSelected: 'cta.selected',
    helpCenterPageView: 'help_center.presented',
    virtualAgentInitiated: 'virtual_agent.initiated',
    virtualAgentFailed: 'virtual_agent.failed',
  },
  egClickStreamEventTypes: {
    pageView: 'Page View',
    impression: 'Impression',
    outcome: 'Outcome',
    interaction: 'Interaction',
  },
  egClickStreamEventCategories: {
    virtualAgent: 'virtual_agent',
    helpCenter: 'help_center',
  },
  egClickStreamEventActionLocation: {
    intentButtons: 'Intent Buttons',
  },
  egClickStreamEventPageName: 'Help Articles',
  egClickStreamEventPageNameDetailed: 'Help Center',
  egClickStreamEventWorkFlowItems: {
    work_flow_list: [
      {
        intent: 'QUESTION_AND_ANSWER',
        automation_status: 'STARTED',
        product_line: 'UNKNOWN',
        order_line_id: '',
        channel: 'WEB',
      },
    ],
  },
};

export const helpCenterPageIdentifiers = {
  pageName: 'page.Customer-Service',
  lineOfBusiness: 'U',
  funnelLocation: '10',
};

export const helpCenterPageIdentifier = `${helpCenterPageIdentifiers.pageName},${helpCenterPageIdentifiers.lineOfBusiness},${helpCenterPageIdentifiers.funnelLocation}`;

export const fallbackError = 'codeFailure';

export const vacLoaderText = {
  header: 'Just one moment',
  subheader: 'While we prepare the Virtual Agent',
};

export const vacEvents = {
  vacConversationCreatedEvent: 'VAC_ConversationCreated',
  vacConversationJoinedEvent: 'VAC_ConversationJoined',
  vacInitializedEvent: 'VAC_Initialized',
  vacLazyInitializedEvent: 'VAC_LazyInitializeFailed',
  vacCreateFrameFailedEvent: 'VAC_CreateFrameFailed',
  vacStartFrameFailedEvent: 'VAC_StartFrameFailed',
  vacConversationCreateFailedEvent: 'VAC_ConversationCreateFailed',
  vacConversationJoinFailedEvent: 'VAC_ConversationJoinFailed',
};

export const VacConfig = {
  VACTimeout: 30000,
  successEventsForEmbedded: [vacEvents.vacConversationCreatedEvent, vacEvents.vacConversationJoinedEvent],
  successEventsForFloating: [vacEvents.vacInitializedEvent],
  errorEvents: [
    vacEvents.vacLazyInitializedEvent,
    vacEvents.vacCreateFrameFailedEvent,
    vacEvents.vacStartFrameFailedEvent,
    vacEvents.vacConversationJoinFailedEvent,
  ],
  vacHandledErrorEvents: [vacEvents.vacConversationCreateFailedEvent, vacEvents.vacConversationJoinFailedEvent],
  errorEventMap: {
    [vacEvents.vacLazyInitializedEvent]: fallbackError,
    [vacEvents.vacCreateFrameFailedEvent]: fallbackError,
    [vacEvents.vacStartFrameFailedEvent]: fallbackError,
  },
  errorConfig: {
    [fallbackError]: {
      iconName: 'sentiment_2',
      errorHeader: "Oops, looks like we've lost the connection",
      errorSubheader: 'In the meantime you can check out some articles from the links below.',
      refreshButton: {
        enabled: true,
        buttonText: 'Refresh',
      },
    },
  },
};
